module.exports = __webpack_public_path__ + "img/avatar5.dfb7f57d.png";